import { FormControl, FormGroup } from '@angular/forms';
import { Filter, FilterValueType } from '../filter';
import { OfferVariantGroup } from '../offer';
import { OfferVariantPost } from '../offer-definition';

/** Offer-group wizard selection, kept so Details can rebuild the variant cards after the step is destroyed. */
export interface ManualVariantSelection {
    selectedValues: unknown[];
    variantSelections: { [groupValueKey: string]: { [variantFilterCode: string]: unknown } };
}

export class FilterData {
    name: string;
    description: string;
    sizeGuide?: number;
    /** Subset of offer documents submitted from the filters step (e.g. sales_mandate). */
    documents?: { type: string; mediaId: number; expiresAt?: string | null }[];
    filters: Filter[];
    filterValues: { [key: string]: FilterValueType };
    filterVariantValues: { [key: string]: FilterValueType[] };
    /** Set when variants come from the offer-group selector rather than the automatic grid. */
    manualVariantSelection?: ManualVariantSelection | null;
    variants: OfferVariantPost[];
    variantGroups: OfferVariantGroup[];
}

export type FilterForm = {
    name: FormControl;
    description: FormControl;
    filters: FormGroup;
    variants: FormGroup;
    sizeGuide?: FormControl;
};
